import {
  createGenerateClassName, jssPreset, MuiThemeProvider, StylesProvider
} from "@material-ui/core/styles";
import "bootstrap/dist/css/bootstrap.min.css";
import { create } from "jss";
import rtl from "jss-rtl";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import "./App.css";
import './Assets/css/animate.min.css';
import "./i18n";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import Store from "./Store/Store";
import GlobalStyles from "./Theme/GlobalStyles";
import { lightTheme } from "./Theme/light";

const Index = () => {
  const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
  const theme = lightTheme;
  localStorage.setItem("themeType", "dark");
  // localStorage.getItem("themeType") === "dark" ? darkTheme : lightTheme;
  // Custom Material-UI class name g  enerator.
  const generateClassName = createGenerateClassName();

  return (
    <StylesProvider jss={jss} generateClassName={generateClassName}>
      <Provider store={Store}>
        <MuiThemeProvider theme={theme}>
          <App />
          <GlobalStyles />
        </MuiThemeProvider>
      </Provider>
    </StylesProvider>
  );
};
ReactDOM.render(
  <React.StrictMode>
    <Index />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
